import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IEvent } from '../../../shared/interfaces/i-events';
import { WebappService } from '../../../shared/services/webapp.service';

@Component({
  selector: 'mobo-event',
  templateUrl: './event.component.html',
  styles: ``,
})
export class EventComponent {
  public selectedEvent?: IEvent;

  constructor(
    public webappService: WebappService,
    public route: ActivatedRoute,
    public router: Router
  ) {}

  ngOnInit() {
    let params = this.route.snapshot.params;
    const campaignEventId = params['id'];
    if (!campaignEventId) {
      this.router.navigate(['']);
      return;
    }
    this.getCampaignsByEvent(campaignEventId);
  }

  async getCampaignsByEvent(campaignEventId: string) {
    this.selectedEvent = (await this.webappService.getCampaignsByEvent(
      campaignEventId
    )) as IEvent;

    if (!this.selectedEvent) {
      this.router.navigate(['']);
      return;
    }
  }
}
